<template>
    <div>
        <img src="/source/png/nftwerks-logo.png" class="site-logo" alt="NFTWerks" />
    </div>
</template>

<script>
export default {
    data() { return {} },
    mounted() {},
    methods: {},
    beforeDestroy() {},
}
</script>
<style lang="scss" scoped>
.site-logo {
    height: 40px;
    width: auto;
    object-fit: contain;
    display: block;
}
@media screen and (max-width: 1081px) {
    .site-logo {
        height: 32px;
    }
}
</style>
